import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'azcMoment', pure: true })
export class AzcMomentPipe implements PipeTransform {
	constructor( @Inject(LOCALE_ID) private _locale: string) { }

	transform(value: any, pattern = 'D MMM YYYY'): string | null {
		if (isBlank(value) || value !== value) {
			return null;
		}

		if (typeof value === 'string') {
			value = value.trim();
		}

		return moment(value).locale(this._locale).format(pattern);
	}
}

function isBlank(obj: any): boolean {
	return obj == null || obj === '';
}
